import { render, staticRenderFns } from "./LimitsListEditor.vue?vue&type=template&id=5c06df17&scoped=true&"
import script from "./LimitsListEditor.vue?vue&type=script&lang=js&"
export * from "./LimitsListEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c06df17",
  null
  
)

export default component.exports